import FeaturePage from "../components/FeaturePage";
import { Package, ShoppingCart, Wallet, FileText, BarChart3, Users, Briefcase, Globe, Mail, Megaphone, Box, Settings } from "lucide-react";

export default function Modules() {
  const modules = [
    { icon: <Package size={22} />, title: "Inventory", desc: "Multi-warehouse stock, barcodes, transfers, low-stock alerts." },
    { icon: <ShoppingCart size={22} />, title: "Orders", desc: "POS, online store, marketplace, all unified into one queue." },
    { icon: <Wallet size={22} />, title: "Payments", desc: "Card, transfer, USSD, mobile money — global processing." },
    { icon: <FileText size={22} />, title: "Invoicing", desc: "Branded invoices, recurring billing, payment links." },
    { icon: <BarChart3 size={22} />, title: "Analytics", desc: "Profit reports, cohorts, top SKUs, custom dashboards." },
    { icon: <Users size={22} />, title: "Customers (CRM)", desc: "Profiles, history, segmentation, loyalty rewards." },
    { icon: <Briefcase size={22} />, title: "Staff", desc: "Roles, permissions, time tracking, performance reports." },
    { icon: <Globe size={22} />, title: "Storefront", desc: "Drag-and-drop website builder with custom domains." },
    { icon: <Mail size={22} />, title: "Email & SMS", desc: "Campaigns, broadcasts, drip flows, transactional emails." },
    { icon: <Megaphone size={22} />, title: "Marketing", desc: "Discounts, coupons, loyalty programs, referral codes." },
    { icon: <Box size={22} />, title: "Shipping", desc: "Real-time rates, label printing, tracking, returns." },
    { icon: <Settings size={22} />, title: "Automations", desc: "Visual workflow builder for any repetitive process." },
  ];

  return (
    <FeaturePage
      badge="Modules"
      title="Build your stack."
      highlight="One module at a time."
      subtitle="Brivo is modular — pick exactly the features you need today, then enable more as your business grows. No painful migrations, no surprise pricing."
      heroImage="https://images.unsplash.com/photo-1766430342829-9896223959db?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      heroBg="cream"
      features={modules}
      details={[
        {
          tag: "Modular by design",
          title: "Start lean. Scale as you go.",
          desc: "Every Brivo customer starts with the modules they need today. Add more anytime — they activate instantly and inherit all your existing data.",
          bullets: ["Activate modules in one click", "All modules share one database", "Pricing scales with usage, not seats"],
        },
        {
          tag: "Integrations",
          title: "Plays nicely with the tools you already use.",
          desc: "Native integrations with Shopify, WooCommerce, QuickBooks, Xero, Mailchimp, and 5,000+ apps via Zapier. Plus open APIs for custom builds.",
        },
      ]}
      useCases={[
        { title: "Lean starter kit", desc: "Inventory + POS + Payments — perfect launchpad." },
        { title: "Online seller", desc: "Storefront + Inventory + Marketing — the e-commerce trio." },
        { title: "Service business", desc: "Invoicing + CRM + Email — invoice, follow up, retain." },
        { title: "Full ops suite", desc: "All 12 modules — for businesses that want everything." },
      ]}
      ctaTitle="Build your perfect stack."
      ctaSubtitle="Activate the modules you need now. Add more anytime, with zero migrations."
      ctaAccent="mint"
    />
  );
}
